import React, { useCallback } from "react";

// To be used with local data
// See useSearch.ts for server search
export function useLocalSearch<T>(data: T[], fields: (keyof T)[]) {
  const [searchTerm, setSearchTerm] = React.useState<string>("");

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  const handleSearch = (event: any) => {
    const term = event.target.value;
    setSearchTerm(term);
  };

  const handleOnClear = () => setSearchTerm("");

  return {
    filteredData: searchTerm ? filterData<T>(data, searchTerm, fields) : data,
    searchTerm,
    handleSearch,
    handleOnClear,
  };
}

export const useLocalSearchByFields = <T>(fields: (keyof T)[]) => {
  const [searchTerm, setSearchTerm] = React.useState<string>("");

  const handleSearch = (searchTerm: string) => {
    setSearchTerm(searchTerm);
  };

  const filter = useCallback(
    (item: T) => {
      return filterItem(item, searchTerm, fields);
    },
    [searchTerm, fields]
  );

  return {
    searchTerm,
    filter,
    handleSearch,
  };
};

function filterData<T>(data: T[], term: string, fields: (keyof T)[]) {
  return data.filter((item) => filterItem(item, term, fields));
}

function filterItem<T>(item: T, term: string, fields: (keyof T)[]) {
  return (
    !sanitize(term) ||
    fields.some((field) => sanitize(item[field]?.toString()).includes(sanitize(term)))
  );
}

function sanitize(term: string | null | undefined): string {
  return term?.trim().toLowerCase() ?? "";
}
